import Axe from "axe-core";
import { createUseStyles } from "react-jss";

export default createUseStyles({
    issueContainer: {
        fontSize: "13px",
        fontFamily: "Open Sans",
        borderBottom: "1px solid #eee",
        padding: [[10, 0]],
    },
    issuePanelHeader: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        justifyContent: "flex-end",
    },
    issuePanelHeaderTitle: {
        marginRight: "auto",
    },
    issueValue: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: "center",
        justifyContent: "flex-end",
    },
    issueLabel: {
        marginRight: "auto",
    },
    issueDetails: {
        paddingTop: 10,
        paddingRight: 29,
        overflow: "hidden",
        boxSizing: "border-box",
    },
    issueElementHtml: {
        width: "100%",
        background: "#333E5B",
        fontSize: "12px",
        outline: "none",
        color: "white",
        border: 0,
        borderRadius: 5,
        padding: [[6, 10]],
        boxSizing: "border-box",
        resize: "none",
        cursor: "pointer",

        "&:active, &:focus": {
            color: "#F68A5A",
        },
    },
    issueNodeCount: {
        fontSize: "8px",
        outline: "none",
        border: 0,
        background: "#0d67cb",
        color: "white",
        textAlign: "right",
        padding: [[4, 8]],
        marginRight: 6,
        borderRadius: 50,
    },
    issueSeverity: {
        fontSize: "12px",
        outline: "none",
        border: 0,
        background: (severity: Axe.ImpactValue) =>
            severity === "critical" ? "#cc3300" : "#ffcc00",
        color: "white",
        textAlign: "right",
        padding: [[6, 10]],
        marginLeft: 5,
        marginRight: 6,
        borderRadius: 50,
    },
    issueElements: {
        margin: [[5, 0]],
        marginTop: 10,
        fontWeight: 700,
        fontSize: "10px",
    },
    issueDetailsIcon: {
        fontSize: "12px",
        padding: 4,
        cursor: "pointer",
        userSelect: "none",
    },
    issueDetailsIconActive: {
        color: "#00A9E8",
    },
});
